import { Box, Text, Stack, Skeleton, SkeletonCircle } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { LinkTo } from "../../nav/components/LinkTo";
import "./index.css";
import { NAV_ITEMS_BY_ROLE } from "./components/sidebar.constatnt";
import { useState, useContext } from "react";
import { BiLogOut } from "react-icons/bi";
import { UserProfileContext } from "../../../context/UserContext";
import { hasUserType, USER_TYPES } from "../../../utils/userRole";
import OvendLogo from "../../nav/components/OvendLogo";
import { useDispatch, useSelector } from "react-redux";
import { PRIMARY_HEX } from "../../../theme/primary";
import { useMediaQuery } from "@chakra-ui/media-query";
import RightControls from "../../nav/RightControls";
import { authClearUser } from "../../../store/actions/authAction";

const SideBar = ({ toggle }) => {
  // const getBrandColor = useSelector(state => state.auth?.brandColor)
  // const adminId = useSelector(state => state.auth?.adminId)
  // const companyCode = useSelector(state => state.auth?.companyCode)
  const [companyProfile] = useState([]);
  const [company = {}] = companyProfile;
  const { userProfile, notifications, isLoading, activeAccount } =
    useContext(UserProfileContext) || {};
  const effectiveRole =
    activeAccount?.type === "vtu"
      ? USER_TYPES.VTU_USER
      : USER_TYPES.ESTATE_MEMBER;
  const navItems =
    NAV_ITEMS_BY_ROLE[effectiveRole] || NAV_ITEMS_BY_ROLE[USER_TYPES.ESTATE_MEMBER];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobile] = useMediaQuery("(max-width: 600px)");
  const pageColor = PRIMARY_HEX;
  const unReadNotifications = notifications?.filter((n) => n?.isRead === false);
  //get company profile data
  // useEffect(() => {
  //   const payload = {
  //     companyCode,
  //     adminId,
  //   }

  // }, [companyCode, adminId])

  const handleLogout = () => {
    try {
      localStorage.removeItem("WMS#221#");
      localStorage.removeItem("ACTIVE_ACCOUNT");
      localStorage.removeItem("WMS_USER");
    } catch (e) {
      // ignore
    }
    dispatch(authClearUser());
    navigate("/login");
  };

  return (
    <Box className="sidebar">
      {isMobile && (
        <Box className="sidebar-backdrop" onClick={() => toggle && toggle()} />
      )}
      <Box className="sidebar-inner">
        <Flex className="brand-style" bg="#fff">
          <RouterLink to="/">
            <Flex className="brand-style">
              <OvendLogo />
            </Flex>
          </RouterLink>
          <Box pl="12px">
            <Text fontSize={["15px"]}>{company?.companyName}</Text>
          </Box>
        </Flex>
        <Flex flex={1} flexDirection="column">
          {isLoading
            ? Array.from({ length: 6 }).map((_, id) => (
                <Flex
                  key={id}
                  alignItems="center"
                  px="16px"
                  py="10px"
                  gap="12px"
                >
                  <SkeletonCircle size="5" />
                  <Skeleton height="14px" width="65%" borderRadius="6px" />
                </Flex>
              ))
            : navItems.map(({ title, to, icon: Icon, children }, id) => (
                <Box key={id}>
                  <LinkTo
                    to={to}
                    title={title}
                    toggle={toggle}
                    id={1}
                    iconComponent={Icon}
                  />
                  {Array.isArray(children) && children.length > 0 ? (
                    <Box pl="20px" mt="-6px">
                      {children.map((childItem, childIndex) => (
                        <LinkTo
                          key={`${id}-${childIndex}`}
                          to={childItem.to}
                          title={childItem.title}
                          toggle={toggle}
                          iconComponent={() => (
                            <Box
                              w="8px"
                              h="8px"
                              borderRadius="full"
                              bg="gray.400"
                            />
                          )}
                        />
                      ))}
                    </Box>
                  ) : null}
                </Box>
              ))}
        </Flex>

        {isMobile && (
          <Box px={3} pt={2}>
            <RightControls
              isMobile={isMobile}
              pageColor={pageColor}
              userProfile={userProfile}
              unReadNotifications={unReadNotifications}
              navigate={navigate}
            />
          </Box>
        )}

        <Box className="link">
          <Stack
            cursor="pointer"
            onClick={handleLogout}
            direction="row"
            alignItems="center"
          >
            <BiLogOut />
            <Text>Log out</Text>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
export default SideBar;
